import { deleteDoc, doc, getDoc, setDoc } from "firebase/firestore";
import moment from "moment/moment";
import React, { useEffect, useRef, useState } from "react";
import { AiFillStar, AiOutlineFileSync } from "react-icons/ai";
import { auth, db, functions } from "../../config/firebase-config";
import { useDispatch, useSelector } from "react-redux";
import { FaFileDownload, FaLanguage, FaUsers } from "react-icons/fa";
import {
  BiChevronRight,
  BiChevronUp,
  BiEdit,
  BiSave,
  BiTime,
} from "react-icons/bi";
import { IoClose, IoMail } from "react-icons/io5";
import { FcCalendar, FcClock } from "react-icons/fc";
import { httpsCallable } from "firebase/functions";
import ReactPlayer from "react-player";
import { toast } from "react-toastify";
import { theme } from "../../utils/theme";
import { CircularProgress } from "@mui/material";
import { partialUpdateUser, getUser } from "../../services/UserService"
import { partialUpdateMeetings, deleteMeetings } from "../../services/MeetingService"

const PastTranscript = ({
  data,
  updateLocally,
  openedTranscript,
  setOpenedTranscript,
  idx,
  page,
  setPage,
  fetchPaginationMeetings
}) => {
  const { userData } = useSelector((state) => state.authReducer);
  const [open, setOpen] = useState(false);
  const [transcriptOpen, setTranscriptOpen] = useState(false);
  const audioPlayerRef = useRef(null);
  //transcript content
  const getTranscriptContent = httpsCallable(functions, "getTranscriptContent");
  const getTranscriptJSON = httpsCallable(functions, "getTranscriptInJSON", {
    timeout: 540000,
  });
  const [transcriptContent, setTranscriptContent] = useState();
  const [transcriptJSON, setTranscriptJSON] = useState();
  const [transcriptLoading, setTranscriptLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [transliteration, setTransliteration] = useState(false);
  const transliterate = httpsCallable(functions, "transliterate", {
    timeout: 540000,
  });
  const [videoOpen, setVideoOpen] = useState(false);
  // console.log("data from past transcript - ", data);

  useEffect(() => {
    if (
      !data?.transliterationAvailable &&
      data.language === "hindi" &&
      transliteration &&
      !loading
    ) {
      toast.info("We are transliterating your summary");
      setLoading(true);
      const summArray = [];
      summArray.push(data?.summary || "");
      transliterate({
        summary: summArray,
        notes: data?.notes?.map((item) => item.name) || [""],
        questions: data?.questions?.map((item) => item.name) || [""],
        tasks: data?.tasks?.map((item) => item.name) || [""],
        tasksForOthers: data?.tasksForOthers?.map((item) => item.name) || [""],
      })
        .then((res) => {
          let newData = res?.data?.transliterated_text;
          if (res?.data?.transliterated_text) {
            const newParticipants = data.participants;
            newParticipants[data.participant] = {
              ...newParticipants[data.participant],
              tasks: data?.tasks?.map((item, i) => {
                return { ...item, transName: newData?.tasks[i] };
              }),
              tasksForOthers: data?.tasksForOthers?.map((item, i) => {
                return { ...item, transName: newData?.tasksForOthers[i] };
              }),
            };

            partialUpdateMeetings(data.id, 
              {
                transSummary: newData.summary.map((item) => item).join(" "),
                notes: data?.notes?.map((item, i) => {
                  return { ...item, transName: newData?.notes[i] };
                }),
                questions: data?.questions?.map((item, i) => {
                  return { ...item, transName: newData?.questions[i] };
                }),
                participants: newParticipants,
                transliterationAvailable: true,
              },
                (response) => {
                  fetchPaginationMeetings();
                },
                (error) => {
                  setLoading(false);
                  toast.error("Some error occured, try later");
                }
            )
          }
        })
        .catch(() => {
          setLoading(false);
          toast.error("Some error occured, try later");
        });
    }
  }, [transliteration]);

  console.log(data.fileDetails.audioUrl, "URL from past trancript");

  const updateUserMeetings = async () => {
    return getUser(data.uid,
        (response) => {
          const userdata = response.data;
          return partialUpdateUser(data.uid,
              {
                meetings: userdata.meetings.filter(
                  (meeting) =>
                    meeting.fileId !== data.fileDetails.fileId || meeting.id !== data.id
                ),
              }
          )
        }
    )
  };
  const dispatch = useDispatch();
  useEffect(() => {
    if (openedTranscript === idx) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [openedTranscript]);
  const [rating, setRating] = useState(data?.rating || 0);
  const [favourite, setFavourite] = useState(data?.favourite);
  const [star, setStar] = useState(0);
  const [fileName, setFileName] = useState({
    name: data?.fileDetails?.name || "",
    editing: false,
  });
  const fileNameRef = useRef(null);
  const [hashTag, setHashTag] = useState({
    name:
      data?.fileDetails?.hashTag ||
      (data?.fileDetails?.type.includes("audio")
        ? "#AudioUploads"
        : "#TranscriptUploads"),
    editing: false,
  });
  const hashTagRef = useRef(null);

  const { uploads } = useSelector((state) => state.uploadsReducer);
  const [index, setIndex] = useState();
  useEffect(() => {
    uploads?.forEach((upload, x) => {
      if (upload.id === data.id) setIndex(x);
    });
  }, [data.id, uploads]);

  const [sendMailModal, setSendMailModal] = useState(false);
  const [meetName, setMeetName] = useState(data?.fileDetails?.name || "");
  const [email, setEmail] = useState("");
  const sendMail = httpsCallable(functions, "sendMail");
  const emailRegex = new RegExp(
    "([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])"
  );
  function isValidEmailList(emailList) {
    const trimmedEmailList = emailList.trim();
    if (emailRegex.test(trimmedEmailList)) {
      return true;
    }
    if (trimmedEmailList.includes(",")) {
      const emails = trimmedEmailList.split(",");
      for (let i = 0; i < emails.length; i++) {
        const email = emails[i].trim();
        if (!emailRegex.test(email)) {
          return false;
        }
      }
      return true;
    }
    return false;
  }

  return (
    <div
      id={data.id}
      className="w-full border rounded-md my-[10px] p-[10px] sm:p-[20px]"
    >
      {/* {data.id} */}
      {/* {index} */}
      <div className="mx-auto">
        <div className="flex gap-[10px] items-center justify-between">
          <div className="text-[#0a243f] flex items-center gap-[10px] text-xs md:text-sm 2xl:text-base flex-grow flex-wrap">
            {data?.fileDetails?.name ? (
              fileName.editing ? (
                <input
                  ref={fileNameRef}
                  value={fileName.name}
                  onChange={(e) => {
                    setFileName((val) => {
                      return { ...val, name: e.target.value };
                    });
                  }}
                  className="text-gray-500 outline-none w-[100px]"
                  id="FileName"
                  placeholder="Add File Name"
                />
              ) : (
                data?.fileDetails?.name
              )
            ) : (
              <input
                ref={fileNameRef}
                disabled={!fileName.editing}
                value={fileName.name}
                onChange={(e) => {
                  setFileName((val) => {
                    return { ...val, name: e.target.value };
                  });
                }}
                className="text-gray-500 outline-none w-[100px]"
                id="FileName"
                placeholder="Add File Name"
              />
            )}
            {fileName.editing ? (
              <BiSave
                onClick={() => {
                  setFileName((val) => {
                    return { ...val, editing: false };
                  });
                  partialUpdateMeetings(data.id, { fileDetails: { ...data.fileDetails, name: fileName.name }})
                  const newUploads = uploads;
                  newUploads[index] = {
                    ...newUploads[index],
                    fileDetails: {
                      ...newUploads[index].fileDetails,
                      name: fileName.name,
                    },
                  };
                  import("../../redux/actions/uploadsActions")
                    .then((ac) => dispatch(ac.setUploads(newUploads)))
                    .then(() => {
                      toast.success("File name saved!");
                      updateLocally();
                    });
                }}
                title="Save"
                className="cursor-pointer"
              />
            ) : (
              <BiEdit
                title="Edit"
                className="cursor-pointer"
                onClick={() => {
                  setFileName((val) => {
                    return { ...val, editing: true };
                  });
                  fileNameRef.current?.focus();
                }}
              />
            )}
            <span className="text-[#07457f] text-xs md:text-sm 2xl:text-base flex items-center gap-[5px]">
              {data?.fileDetails?.hashTag ? (
                hashTag.editing ? (
                  <input
                    ref={hashTagRef}
                    value={hashTag.name}
                    onChange={(e) => {
                      setHashTag((val) => {
                        return { ...val, name: e.target.value };
                      });
                    }}
                    className="text-[#07457f] text-xs md:text-sm 2xl:text-base outline-none w-[100px]"
                    id="HashTag"
                    placeholder="Add Hashtag"
                  />
                ) : (
                  data?.fileDetails?.hashTag
                )
              ) : (
                <input
                  ref={hashTagRef}
                  disabled={!hashTag.editing}
                  value={hashTag.name}
                  onChange={(e) => {
                    setHashTag((val) => {
                      return { ...val, name: e.target.value };
                    });
                  }}
                  className="text-[#07457f] text-xs md:text-sm 2xl:text-base outline-none w-[100px]"
                  id="HashTag"
                  placeholder="Add Hashtag"
                />
              )}
              {hashTag.editing ? (
                <BiSave
                  onClick={() => {
                    setHashTag((val) => {
                      return { ...val, editing: false };
                    });
                    partialUpdateMeetings(data.id, {fileDetails: {...data.fileDetails, hashTag: hashTag.name,}})
                    const newUploads = uploads;
                    newUploads[index] = {
                      ...newUploads[index],
                      fileDetails: {
                        ...newUploads[index].fileDetails,
                        hashTag: hashTag.name,
                      },
                    };
                    import("../../redux/actions/uploadsActions")
                      .then((ac) => dispatch(ac.setUploads(newUploads)))
                      .then(() => {
                        toast.success("Hashtag saved!");
                        updateLocally();
                      });
                  }}
                  title="Save"
                  className="cursor-pointer"
                />
              ) : (
                <BiEdit
                  title="Edit"
                  className="cursor-pointer"
                  onClick={() => {
                    setHashTag((val) => {
                      return { ...val, editing: true };
                    });
                    hashTagRef.current?.focus();
                  }}
                />
              )}
            </span>
            <AiFillStar
              title="Favourite"
              className={`text-sm sm:text-base md:text-lg cursor-pointer text-gray-300 hover:text-yellow-400 ${
                favourite && "text-yellow-400"
              }`}
              onClick={() => {
                setFavourite(!!!data?.favourite);
                partialUpdateMeetings(data.id,
                  { favourite: !!!data?.favourite },
                  (response) => {
                    fetchPaginationMeetings();
                  }
                )
              }}
            />
          </div>
          <div
            onClick={() => {
              setOpen(!open);
              setOpenedTranscript(idx);
            }}
            className="cursor-pointer flex gap-[5px] items-center text-[#6b7b8a] lg:text-sm text-xs"
          >
            Details
            <BiChevronUp
              className={`text-black sm:text-xl transition ${
                open ? "rotate-180" : "rotate-90"
              }`}
            />
          </div>
        </div>
        <div className="flex gap-[10px] md:gap-[20px] items-center text-sm my-[10px] flex-wrap">
          {!!data?.fileDetails?.audioDuration && (
            <div className=" items-center text-gray-500 flex gap-[5px] capitalize min-w-fit">
              <BiTime />
              {parseInt(data?.fileDetails?.audioDuration / 60)}mins{" "}
              {parseInt(data?.fileDetails?.audioDuration % 60)}sec
            </div>
          )}
          {!!data?.language && (
            <div className=" items-center text-gray-500 flex gap-[5px] capitalize min-w-fit">
              <FaLanguage />
              {data?.language}
            </div>
          )}
          {/* {!!data?.fileDetails?.type.includes("audio") && <div className='items-center text-gray-500 flex gap-[5px] min-w-fit'><MdAudioFile /> Converted from audio format</div>} */}
        </div>
        <div className="flex items-center justify-between gap-[20px]">
          <div className="flex gap-[30px] flex-wrap md:text-sm text-xs">
            <div className="flex items-center gap-[10px]">
              <div>
                <FcCalendar className="h-[22px] w-[22px]" />
              </div>
              <div className="text-[#19324B]">
                {moment(moment(data?.createdAt).toDate()).format("ddd, MMM DD")}
              </div>
            </div>
            <div className="flex items-center gap-[10px]">
              <div>
                <FcClock className="h-[22px] w-[22px]" />
              </div>
              <div className="text-[#19324B]">
                {moment(moment(data?.createdAt).toDate()).format("hh:mm A")}
              </div>
            </div>
            {data?.fileDetails?.url && (
              <a href={data?.fileDetails?.url} title="Download transcript">
                <FaFileDownload
                  style={{ color: theme.color }}
                  className="h-[18px] w-[18px"
                />
              </a>
            )}
          </div>
          {data?.language === "hindi" && open && (
            <div
              onClick={() => {
                setTransliteration((t) => !t);
              }}
              className={`w-[60px] p-[2px] rounded-full transition flex items-center cursor-pointer shadow-inner ${
                transliteration
                  ? "shadow-[#07457f] bg-[#2c74b3] justify-end"
                  : "bg-gray-200 shadow-gray-500 justify-start"
              }`}
            >
              <div className="p-[10px] shadow-md shadow-black/40 rounded-full bg-gray-100 border-white border-2 relative flex justify-center items-center">
                {transliteration ? (
                  <span className="absolute text-xs">Hi</span>
                ) : (
                  <span className="absolute text-xs">हि</span>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className={`w-full ${!open ? "hidden" : "fade"} my-[10px]`}>
        <div className="px-[10px] sm:px-[20px]">
          <div className="sm:flex sm:flex-row flex-col gap-[10px] items-start">
            <div className="text-[#6b7b8a] text-sm 2xl:text-base font-semibold min-w-fit">
              Call Summary :{" "}
            </div>
            <div className="text-justify text-sm 2xl:text-base flex-grow">
              {data?.transliterationAvailable && transliteration
                ? data?.transSummary
                : data?.summary}
            </div>
          </div>
        </div>
        <div className="flex flex-wrap py-[10px] mx-auto ">
          {!!data?.notes && data?.notes?.length > 0 && (
            <ul className="list-disc md:w-[50%]  bg-[#fafefe] relative">
              <div className="absolute translate-x-[-100%] top-[10px] left-0 px-[8px] py-[20px] bg-[#ddf8f9]"></div>
              <div className="3xl:text-xl text-[18px] font-bold pt-[3%] pb-[10px] text-[#212121] px-[20px]">
                Important Notes
              </div>
              <div className="h-[250px] overflow-auto px-[20px]">
                {data &&
                  data.notes.map((item, idx) => {
                    return (
                      <div
                        className="flex items-start my-[5px] gap-[5px]"
                        key={idx}
                      >
                        <input
                          onChange={() => {
                            const newNotes = data.notes;
                            newNotes[idx] = {
                              ...item,
                              completed: !item.completed,
                            };
                            partialUpdateMeetings(data.id, { notes: newNotes })
                            
                            const newUploads = uploads;
                            newUploads[index] = {
                              ...newUploads[index],
                              notes: newNotes,
                            };
                            import("../../redux/actions/uploadsActions").then(
                              (ac) => dispatch(ac.setUploads(newUploads))
                            );
                          }}
                          checked={item?.completed}
                          type="checkbox"
                          name=""
                          id=""
                          className="mt-[5px] cross-checkbox"
                        />
                        <div
                          className={`text-sm 2xl:text-base ${
                            item.completed && "text-gray-300"
                          } transition`}
                        >
                          {data?.transliterationAvailable && transliteration
                            ? item?.transName
                            : item?.name}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </ul>
          )}
          {!!data?.tasks && data?.tasks?.length > 0 && (
            <ul className="list-disc md:w-[50%] bg-[#f8fef6] relative  ">
              <div className="absolute translate-x-[-100%] top-[10px] left-0 px-[8px] py-[20px] bg-[#c4f7b6]"></div>
              <div className="3xl:text-xl text-[18px] font-bold pt-[3%] pb-[10px] text-[#212121] px-[20px]">
                Assigned to me
              </div>
              <div className="h-[250px] overflow-auto px-[20px]">
                {data &&
                  data.tasks.map((item, idx) => {
                    return (
                      <div
                        className="flex items-start my-[5px] gap-[5px]"
                        key={idx}
                      >
                        {/* {item?.shortName} */}
                        <input
                          onChange={() => {
                            const newTasks = data.tasks;
                            newTasks[idx] = {
                              ...item,
                              completed: !item.completed,
                            };
                            const newParticipants = data.participants;
                            newParticipants[data.participant] = {
                              ...newParticipants[data.participant],
                              tasks: newTasks,
                            };
                            partialUpdateMeetings(data.id, { participants: newParticipants })
                            const newUploads = uploads;
                            newUploads[index] = {
                              ...newUploads[index],
                              participants: newParticipants,
                            };
                            import("../../redux/actions/uploadsActions").then(
                              (ac) => dispatch(ac.setUploads(newUploads))
                            );
                          }}
                          checked={item?.completed}
                          type="checkbox"
                          name=""
                          id=""
                          className="mt-[5px] cross-checkbox"
                        />
                        <div
                          className={`text-sm 2xl:text-base ${
                            item.completed && "text-gray-300"
                          } transition`}
                        >
                          {data?.transliterationAvailable && transliteration
                            ? item?.transName
                            : item?.name}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </ul>
          )}
          {!!data?.questions && data?.questions?.length > 0 && (
            <ul className="list-disc md:w-[50%]  bg-[#fefef9] relative ">
              <div className="absolute translate-x-[-100%] top-[10px] left-0 px-[8px] py-[20px] bg-[#f9f8cb]"></div>
              <div className="3xl:text-xl text-[18px] font-bold pt-[3%] pb-[10px] text-[#212121] px-[20px]">
                Questions
              </div>
              <div className="h-[250px] overflow-auto px-[20px]">
                {data &&
                  data?.questions.map((item, idx) => {
                    return (
                      <div
                        className="flex items-start my-[5px] gap-[5px]"
                        key={idx}
                      >
                        <input
                          onChange={() => {
                            const newQuestions = data.questions;
                            newQuestions[idx] = {
                              ...item,
                              completed: !item.completed,
                            };
                            partialUpdateMeetings(data.id, { questions: newQuestions })
                            
                            const newUploads = uploads;
                            newUploads[index] = {
                              ...newUploads[index],
                              questions: newQuestions,
                            };
                            import("../../redux/actions/uploadsActions").then(
                              (ac) => dispatch(ac.setUploads(newUploads))
                            );
                          }}
                          checked={item?.completed}
                          type="checkbox"
                          name=""
                          id=""
                          className="mt-[5px] cross-checkbox"
                        />
                        <div
                          className={`text-sm 2xl:text-base ${
                            item.completed && "text-gray-300"
                          } transition`}
                        >
                          {data?.transliterationAvailable && transliteration
                            ? item?.transName
                            : item?.name}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </ul>
          )}
          {!!data?.tasksForOthers && data?.tasksForOthers?.length > 0 && (
            <ul className="list-disc md:w-[50%] bg-[#fffaf4] relative  ">
              <div className="absolute translate-x-[-100%] top-[10px] left-0 px-[8px] py-[20px] bg-[#ffddac]"></div>
              <div className="3xl:text-xl text-[18px] font-bold pt-[3%] pb-[10px] text-[#212121] px-[20px]">
                Assigned to Others
              </div>
              <div className="h-[250px] overflow-auto px-[20px]">
                {data &&
                  data?.tasksForOthers.map((item, idx) => {
                    return (
                      <div
                        className="flex items-start my-[5px] gap-[5px]"
                        key={idx}
                      >
                        <input
                          onChange={() => {
                            const newTFO = data.tasksForOthers;
                            newTFO[idx] = {
                              ...item,
                              completed: !item.completed,
                            };
                            const newParticipants = data.participants;
                            newParticipants[data.participant] = {
                              ...newParticipants[data.participant],
                              tasksForOthers: newTFO,
                            };
                            partialUpdateMeetings(data.id, { participants: newParticipants });
                            const newUploads = uploads;
                            newUploads[index] = {
                              ...newUploads[index],
                              participants: newParticipants,
                            };
                            import("../../redux/actions/uploadsActions").then(
                              (ac) => dispatch(ac.setUploads(newUploads))
                            );
                          }}
                          checked={item?.completed}
                          type="checkbox"
                          name=""
                          id=""
                          className="mt-[5px] cross-checkbox"
                        />
                        <div
                          className={`text-sm 2xl:text-base ${
                            item.completed && "text-gray-300"
                          } transition`}
                        >
                          {data?.transliterationAvailable && transliteration
                            ? item?.transName
                            : item?.name}
                        </div>
                      </div>
                    );
                  })}
              </div>
            </ul>
          )}
        </div>
        <div className=" text-[#6b7b8a] px-[10px] sm:px-[20px]">
          <div className="my-[10px]">
            created: {moment(moment(data?.createdAt)?.toDate()).format("MMM DD, YYYY")}
          </div>
          <div className="my-[10px] flex items-center gap-[5px]">
            Rate the above Summary?
            {[1, 2, 3, 4, 5].map((x, idx) => {
              return (
                <AiFillStar
                  onMouseEnter={() => {
                    setStar(x);
                  }}
                  onMouseLeave={() => {
                    setStar(0);
                  }}
                  onClick={() => {
                    setRating(x);
                    partialUpdateMeetings(data.id,
                      { rating: x },
                      (response) => {
                        fetchPaginationMeetings();
                      }
                    );
                  }}
                  key={idx}
                  className={`transitionFast cursor-pointer ${
                    x <= star || x <= rating
                      ? "text-yellow-400"
                      : "text-gray-300"
                  }`}
                />
              );
            })}
          </div>
          {/* {(!!data?.fileDetails?.type.includes("audio") ||
            !!data?.fileDetails?.type.includes("video")) && (
            <div
              className={`w-full bg-[#f1f3f4] ${
                data?.fileDetails?.type.includes("audio")
                  ? "h-[50px]"
                  : "h-screen"
              }`}
            >
              <ReactPlayer
                ref={audioPlayerRef}
                url={data.fileDetails.audioUrl}
                controls
                height={
                  data?.fileDetails?.type.includes("audio") ? "50px" : "100%"
                }
                width={"100%"}
              />
            </div>
          )} */}
          {(!!data?.fileDetails?.type.includes("audio") ||
            !!data?.fileDetails?.type.includes("video")) && (
            <div className="relative">
              <div
                onClick={() => {
                  setVideoOpen(!videoOpen);
                }}
                className="flex items-center cursor-pointer my-[10px] gap-[10px]"
              >
                <div>
                  <AiOutlineFileSync />
                </div>
                <div className="font-semibold">
                  {data?.fileDetails?.type.includes("audio")
                    ? "Audio"
                    : "Video"}
                </div>
                <div>
                  <BiChevronRight
                    className={`${
                      videoOpen ? "rotate-90" : ""
                    } transition text-xl`}
                  />
                </div>
              </div>

              {videoOpen && (
                <div
                  className={`w-full bg-[#f1f3f4] ${
                    data?.fileDetails?.type.includes("audio")
                      ? "h-[50px]"
                      : "auto"
                  }`}
                >
                  <ReactPlayer
                    ref={audioPlayerRef}
                    url={data.fileDetails.audioUrl} // Assuming audioUrl is also applicable for video
                    controls
                    height={
                      data?.fileDetails?.type.includes("audio")
                        ? "50px"
                        : "auto%"
                    }
                    width={"100%"}
                  />
                </div>
              )}
            </div>
          )}

          <div
            onClick={() => {
              setTranscriptOpen(!transcriptOpen);
            }}
            className="flex items-center cursor-pointer my-[10px] gap-[10px]"
          >
            <div>
              <AiOutlineFileSync />
            </div>
            <div className="font-semibold">Transcript</div>
            <div>
              <BiChevronRight
                className={`${
                  transcriptOpen ? "rotate-90" : ""
                } transition text-xl`}
              />
            </div>
          </div>
          {transcriptOpen && (
            <div className="p-[10px] rounded-md bg-gray-300 fade">
              {data?.transcript ? (
                <div className="text-sm whitespace-break-spaces text-gray-600 max-h-[400px] overflow-auto">
                  {data?.transcript}
                </div>
              ) : (
                <div className="text-sm whitespace-break-spaces text-gray-600 max-h-[350px] overflow-auto">
                  {transcriptJSON ? (
                    <div>
                      <div>WEBVTT</div>
                      <br />
                      {transcriptJSON.map((item, idx) => {
                        return (
                          <div
                            onClick={() => {
                              const hours = item.startTime.split(":")[0];
                              const minutes = item.startTime.split(":")[1];
                              const seconds = item.startTime.split(":")[2];
                              if (audioPlayerRef.current) {
                                audioPlayerRef.current.seekTo(
                                  parseFloat(hours) * 60 * 60 +
                                    parseFloat(minutes) * 60 +
                                    parseFloat(seconds)
                                );
                                audioPlayerRef.current
                                  .getInternalPlayer()
                                  .play();
                              }
                            }}
                            key={idx}
                            className="my-[10px] p-[2.5px] rounded-md cursor-pointer hover:text-black hover:bg-gray-200 transition"
                            title={`Play this part 👆`}
                          >
                            <div className="flex items-center gap-[5px]">
                              {item.startTime} --&gt; {item.endTime}
                            </div>
                            <div>
                              {item.speaker}: {item.content}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  ) : transcriptLoading ? (
                    "Loading..."
                  ) : transcriptContent ? (
                    transcriptContent
                  ) : (
                    "No Transcript Available"
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <div className="flex items-center gap-[10px] mt-[10px] text-xs sm:text-sm 2xl:text-base">
        {/* {(data?.summary ||
          data?.notes.length > 0 ||
          data?.tasks?.length > 0 ||
          data?.tasksForOthers?.length > 0 ||
          data?.questions.length > 0) && (
          <div
            className="shadow-sm fade text-white py-[5px] px-[10px] cursor-pointer rounded-md transition bg-[#07457f]"
            onClick={() => {
              setSendMailModal(true);
            }}
          >
            Send notes
          </div>
        )} */}

        <div
          className="text-red-500 rounded-md fade py-[5px] px-[10px] cursor-pointer"
          onClick={() => {
            setConfirmDelete(true);
          }}
        >
          Delete
        </div>
      </div>
      {confirmDelete && (
        <div className="h-[100vh] w-[100vw] bg-[rgba(0,0,0,0.5)] fixed top-0 left-0 flex flex-col z-40 justify-center items-center">
          <div className="w-fit flex flex-col items-end modalAnimation max-w-[85%]">
            <div
              onClick={() => {
                setConfirmDelete(false);
              }}
              className="bg-white cursor-pointer z-30 mb-[10px] w-fit rounded-full p-[2px]"
            >
              <IoClose />
            </div>
            <div
              className={`rounded-md bg-white border-box relative p-[15px] max-h-[85vh] text-sm sm:text-base w-[300px] overflow-auto overflow-x-hidden`}
            >
              <div className="">Are you sure you want to delete it?</div>
              <button
                onClick={() => {
                  setConfirmDelete(false);
                  document
                    .getElementById(data.id)
                    .classList.add("deleteAnimation");

                  deleteMeetings(data.id,
                      (response) => {
                        updateUserMeetings().then(() => {
                          fetchPaginationMeetings();
                        });
                      },
                      (error) => {
                        fetchPaginationMeetings();
                      }
                  )
                }}
                className="py-[5px] w-fit px-[20px] mt-[10px] float-right bg-red-500 text-white rounded-md flex items-center justify-center"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
      {sendMailModal && (
        <div className="h-[100vh] w-[100vw] bg-[rgba(0,0,0,0.5)] fixed top-0 left-0 flex flex-col z-40 justify-center items-center">
          <div className="w-fit flex flex-col items-end modalAnimation max-w-[85%]">
            <div
              onClick={() => {
                setSendMailModal(false);
              }}
              className="bg-white cursor-pointer z-30 mb-[10px] w-fit rounded-full p-[2px]"
            >
              <IoClose />
            </div>
            <div
              className={`rounded-md bg-white border-box relative p-[15px] max-h-[85vh] text-sm sm:text-base w-[500px] max-w-full overflow-auto overflow-x-hidden`}
            >
              <div className="font-medium text-sm sm:text-base xl:text-lg">
                Who is/are the intended recipient(s) of these notes?
              </div>
              <div
                className="border rounded-md p-[5px] mt-[10px] sm:p-[10px] flex items-center gap-[10px]"
                title="Email(s)"
              >
                <IoMail style={{ color: theme.color }} />
                <input
                  type="text"
                  name=""
                  id=""
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-grow outline-none rounded-md"
                  placeholder="Enter email(s)"
                />
              </div>
              <div className="sm:text-xs text-[8px] leading-[10px] mb-[10px]">
                You can enter multiple emails. Emails should be comma-separated,
                otherwise it won't be sent
              </div>
              <div
                className="border rounded-md p-[5px] my-[10px] sm:p-[10px] flex items-center gap-[10px]"
                title="Meet Name"
              >
                <FaUsers style={{ color: theme.color }} />
                <input
                  type="text"
                  name=""
                  id=""
                  value={meetName}
                  onChange={(e) => setMeetName(e.target.value)}
                  className="flex-grow outline-none rounded-md"
                  placeholder="Enter meet name"
                />
              </div>
              <div
                className="shadow-sm fade flex items-center justify-center text-white py-[5px] px-[10px] w-fit cursor-pointer rounded-md transition bg-[#07457f]"
                onClick={() => {
                  if (!isValidEmailList(email)) {
                    toast.error("Enter email(s) in valid format");
                  } else {
                    setLoading(true);
                    sendMail({
                      email: email,
                      meetName: meetName,
                      name: userData?.name || auth.currentUser.displayName,
                      summary: data?.summary,
                      notes: data?.notes?.map((item) => item.name),
                      questions: data?.questions?.map((item) => item.name),
                      tasks: data?.tasks?.map((item) => item.name),
                      tasksForOthers: data?.tasksForOthers?.map(
                        (item) => item.name
                      ),
                    })
                      .then((res) => {
                        console.log(res);
                        toast.success("Mail Sent");
                      })
                      .catch((err) => {
                        toast.error("Some error occured!");
                        console.log(err, "error");
                      })
                      .finally(() => {
                        setLoading(false);
                        setSendMailModal(false);
                      });
                  }
                }}
              >
                {loading ? (
                  <CircularProgress
                    style={{ width: "20px", height: "20px", color: "white" }}
                  />
                ) : (
                  "Send"
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PastTranscript;
